<template>
    <el-dialog append-to-body :visible.sync="showTag" width="30%">
        <div slot="title" class="flex aic">
            <i class="el-icon-circle-close color_red"></i><span class="ml10">无法预约该日</span>
        </div>
        <div style="margin-top: -20px">
            <p v-if="status==='BE_OVERDUE'">
                已逾期
            </p>

            <p v-if="status==='NO_NUMBER_SOURCE'">
                当天体检名额已约满，请尝试预约其他日期
            </p>

            <div v-if="status==='LACK_MEDICAL_SKILLS'">
                当天缺少您体检所需的以下资源： <br><br>
                <p v-for="(item,index) in list" class="color_main" :key="index" style="line-height: 1.5">
                    {{item.combinationItemName}}
                </p>
            </div>
        </div>
    </el-dialog>
</template>

<script>
  import {DiaLogMixin} from "../../../common/lib/mixins/dialog-base";

  export default {
    name: "dialog-error",
    mixins: [DiaLogMixin],
    data() {
      return {
        status: '',
        list: []
      }
    },
    methods: {
      open(data, list) {
        this.show();
        this.list = list;
        this.status = data;
      }
    },
  }
</script>

<style scoped lang="scss">
    .el-icon-circle-close {
        font-size: 20px !important;
    }
</style>
